//@flow

import {getRelatedResourcesApi} from './api';
import type {
  RelatedResourceParams,
  RelatedResource,
  RelatedResourceResponse,
} from '../../entities';

function relatedResourceResponseAdapter(
  response: RelatedResourceResponse
): RelatedResource {
  if (response.categories) {
    return {
      criteria: 'CATEGORIES',
      resources: response.categories.map(category => ({
        name: category.name,
        id: category.id,
        imageId: category.portraitImageId,
      })),
    };
  }
  if (response.subCategories) {
    return {
      criteria: 'SUBCATEGORIES',
      resources: response.subCategories.map(subCategory => ({
        name: subCategory.name,
        id: subCategory.id,
      })),
    };
  }
  if (response.products) {
    return {
      criteria: 'PRODUCTS',
      resources: response.products.map(product => ({
        name: product.name,
        id: product.id,
        imageId: product.mainImageId,
      })),
    };
  }
  throw new Error('Invalid response');
}

export function getRelatedResourcesService(
  params: RelatedResourceParams
): Promise<RelatedResource> {
  const paramsFormatted = Object.keys(params).reduce((acc, key) => {
    const value = params[key];
    if (value && value.length > 0) {
      acc[key] = value.join(',');
    }
    return acc;
  }, {});

  return getRelatedResourcesApi(paramsFormatted)
    .toPromise()
    .then(response => {
      return relatedResourceResponseAdapter(response);
    });
}
